import { SubTravelInfoResourceConfig } from './subTravelInfoResourceConfig';

export class SubTravellersResourceConfig {
  title = 'sub-travellers-title';
  travelInfoResourceConfig: SubTravelInfoResourceConfig = new SubTravelInfoResourceConfig();
}
